
    import {computed, ComputedRef, defineComponent, reactive, watch, onMounted, nextTick, onUnmounted} from 'vue'
    import {useStore} from "@/store";
    import {useRoute} from "vue-router";
    import utils from '@/util/index';

    interface State {
        isShowTopTab: boolean; // 显示导航tab
        isShowTopNav: boolean;
        needListenScroll: boolean;
        ceilingList: any;
        currentName: string;
        topValue: number;
        offsetTop: number;
        reportLevel: number;
        checkModules: any;
        logoUrl: string;
        channelType: string;
    }

    const ceilingListAll = [ // 全量委托检测项
        {name: '基础信息', id: 'BaseInfo'},
        {name: '配置信息', id: 'ConfigInfo'},
        {name: '事故检测', id: 'Accident'},
        {name: '火烧检测', id: 'Fire'},
        {name: '泡水检测', id: 'SoakWater'},
        {name: '外观检测', id: 'Appearance'},
        {name: '内饰检测', id: 'Interior'},
        {name: '灯光及电器检测', id: 'Lighting'},
        {name: '动力检测', id: 'Power'},
        {name: '机舱检测', id: 'Machine'},
        {name: '底盘检测', id: 'Bottom'},
        {name: '启动检测', id: 'StartUp'},
        {name: 'ECU检测', id: 'EcuInfo'},
        {name: '附加照片', id: 'PhotoInfo'},
        {name: '备注信息', id: 'RemarksInfo'}
    ]

    export default defineComponent({
        name: "navigation",
        setup() {
            let state: State = reactive({
                isShowTopNav: false, // nav
                isShowTopTab: false, // nav tab
                needListenScroll: true, // 监听滚动
                ceilingList: [],
                currentName: '基础信息',
                topValue: 0,
                offsetTop: 0,
                reportLevel: 0,
                checkModules: [],
                logoUrl: '',
                channelType: ''
            })
            const {query} = useRoute();
            const store = useStore()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const { basicItemInfos, 
                        configureInfos, 
                        accident, 
                        fire, 
                        soakWater, 
                        appearance, 
                        interior, 
                        lighting, 
                        startUp, 
                        ecuInfo, 
                        power, 
                        machine, 
                        bottom, 
                        photoList, 
                        carSummaryInfo,
                        checkModules,
                        reportConfigInfo } = data;
                state.reportLevel = Number(`${query.reportLevel}`) || 0;
                state.channelType = `${query.channelType}` || '';
                state.checkModules = checkModules ? checkModules : [];
                state.logoUrl = reportConfigInfo ? reportConfigInfo.logoUrl : '';
                if (state.reportLevel === 0 || state.reportLevel === 8|| state.reportLevel === 32) { // 299&豪车
                    // 基本信息
                    if (basicItemInfos !== null && basicItemInfos.length > 0) {
                        state.ceilingList.push({name: '基础信息', id: 'BaseInfo'})
                    }
                    // 配置信息
                    if (configureInfos !== null && configureInfos.length > 0) {
                        state.ceilingList.push({name: '配置信息', id: 'ConfigInfo'})
                    }
                    // 事故检测
                    if (accident !== null && accident.itemCount > 0) {
                        state.ceilingList.push({name: '事故检测', id: 'Accident'})
                    }
                    // 火烧检测
                    if (fire !== null && fire.itemCount > 0) {
                        state.ceilingList.push({name: '火烧检测', id: 'Fire'})
                    }
                    // 泡水检测
                    if (soakWater !== null && soakWater.itemCount > 0) {
                        state.ceilingList.push({name: '泡水检测', id: 'SoakWater'})
                    }
                    // 附加照片
                    if (photoList !== null && photoList.length > 0) {
                        state.ceilingList.push({name: '附加照片', id: 'PhotoInfo'})
                    }
                    // 备注信息
                    if (carSummaryInfo !== null && carSummaryInfo !== '') {
                        state.ceilingList.push({name: '备注信息', id: 'RemarksInfo'})
                    }
                }
                if (state.reportLevel === 1) { // 499
                    // 基本信息
                    if (basicItemInfos !== null && basicItemInfos.length > 0) {
                        state.ceilingList.push({name: '基础信息', id: 'BaseInfo'})
                    }
                    // 配置信息
                    if (configureInfos !== null && configureInfos.length > 0) {
                        state.ceilingList.push({name: '配置信息', id: 'ConfigInfo'})
                    }
                    // 事故检测
                    if (accident !== null && accident.itemCount > 0) {
                        state.ceilingList.push({name: '事故检测', id: 'Accident'})
                    }
                    // 火烧检测
                    if (fire !== null && fire.itemCount > 0) {
                        state.ceilingList.push({name: '火烧检测', id: 'Fire'})
                    }
                    // 泡水检测
                    if (soakWater !== null && soakWater.itemCount > 0) {
                        state.ceilingList.push({name: '泡水检测', id: 'SoakWater'})
                    }
                    // 外观检测
                    if (appearance && appearance !== null && appearance.itemCount > 0) {
                        state.ceilingList.push({name: '外观检测', id: 'Appearance'})
                    }
                    // 内饰检测
                    if (interior && interior !== null && interior.itemCount > 0) {
                        state.ceilingList.push({name: '内饰检测', id: 'Interior'})
                    }
                    // 灯光及电器检测
                    if (lighting && lighting !== null && lighting.itemCount > 0) {
                        state.ceilingList.push({name: '灯光及电器检测', id: 'Lighting'})
                    }
                    // 启动检测
                    if (startUp && startUp !== null && startUp.itemCount > 0) {
                        state.ceilingList.push({name: '启动检测', id: 'StartUp'})
                    }
                    // ECU检测 && ecuInfo !== null
                    if (ecuInfo) {
                        state.ceilingList.push({name: 'ECU检测', id: 'EcuInfo'})
                    }
                    // 附加照片
                    if (photoList !== null && photoList.length > 0) {
                        state.ceilingList.push({name: '附加照片', id: 'PhotoInfo'})
                    }
                    // 备注信息
                    if (carSummaryInfo !== null && carSummaryInfo !== '') {
                        state.ceilingList.push({name: '备注信息', id: 'RemarksInfo'})
                    }
                }
                if (state.reportLevel === 2 || state.reportLevel === 16) { // 699&交易复检
                    // 基本信息
                    if (basicItemInfos !== null && basicItemInfos.length > 0) {
                        state.ceilingList.push({name: '基础信息', id: 'BaseInfo'})
                    }
                    // 配置信息
                    if (configureInfos !== null && configureInfos.length > 0) {
                        state.ceilingList.push({name: '配置信息', id: 'ConfigInfo'})
                    }
                    // 事故检测
                    if (accident !== null && accident.itemCount > 0) {
                        state.ceilingList.push({name: '事故检测', id: 'Accident'})
                    }
                    // 火烧检测
                    if (fire !== null && fire.itemCount > 0) {
                        state.ceilingList.push({name: '火烧检测', id: 'Fire'})
                    }
                    // 泡水检测
                    if (soakWater !== null && soakWater.itemCount > 0) {
                        state.ceilingList.push({name: '泡水检测', id: 'SoakWater'})
                    }
                    // 外观检测
                    if (appearance && appearance !== null && appearance.itemCount > 0) {
                        state.ceilingList.push({name: '外观检测', id: 'Appearance'})
                    }
                    // 内饰检测
                    if (interior && interior !== null && interior.itemCount > 0) {
                        state.ceilingList.push({name: '内饰检测', id: 'Interior'})
                    }
                    // 灯光及电器检测
                    if (lighting && lighting !== null && lighting.itemCount > 0) {
                        state.ceilingList.push({name: '灯光及电器检测', id: 'Lighting'})
                    }
                    // 机舱检测
                    if (machine && machine !== null && machine.itemCount > 0) {
                        state.ceilingList.push({name: '机舱检测', id: 'Machine'})
                    }
                    // 动力检测
                    if (power && power !== null && power.itemCount > 0) {
                        state.ceilingList.push({name: '动力检测', id: 'Power'})
                    }
                    // 底盘检测
                    if (bottom && bottom !== null && bottom.itemCount > 0) {
                        state.ceilingList.push({name: '底盘检测', id: 'Bottom'})
                    }
                    // 启动检测
                    if (startUp && startUp !== null && startUp.itemCount > 0) {
                        state.ceilingList.push({name: '启动检测', id: 'StartUp'})
                    }
                    // ECU检测 && ecuInfo !== null
                    if (ecuInfo) {
                        state.ceilingList.push({name: 'ECU检测', id: 'EcuInfo'})
                    }
                    // 附加照片
                    if (photoList !== null && photoList.length > 0) {
                        state.ceilingList.push({name: '附加照片', id: 'PhotoInfo'})
                    }
                    // 备注信息
                    if (carSummaryInfo !== null && carSummaryInfo !== '') {
                        state.ceilingList.push({name: '备注信息', id: 'RemarksInfo'})
                    }
                }
                if (state.reportLevel === 4) { // 质保
                    // 基本信息
                    if (basicItemInfos !== null && basicItemInfos.length > 0) {
                        state.ceilingList.push({name: '基础信息', id: 'BaseInfo'})
                    }
                    // 配置信息
                    // if (configureInfos !== null && configureInfos.length > 0) {
                    //     state.ceilingList.push({name: '配置信息', id: 'ConfigInfo'})
                    // }
                    // 机舱检测
                    if (machine && machine !== null && machine.itemCount > 0) {
                        state.ceilingList.push({name: '机舱检测', id: 'Machine'})
                    }
                    // 动力检测
                    if (power && power !== null && power.itemCount > 0) {
                        state.ceilingList.push({name: '动力检测', id: 'Power'})
                    }
                    // 底盘检测
                    if (bottom && bottom !== null && bottom.itemCount > 0) {
                        state.ceilingList.push({name: '底盘检测', id: 'Bottom'})
                    }
                    // 启动检测
                    if (startUp && startUp !== null && startUp.itemCount > 0) {
                        state.ceilingList.push({name: '启动检测', id: 'StartUp'})
                    }
                    // 附加照片
                    if (photoList !== null && photoList.length > 0) {
                        state.ceilingList.push({name: '附加照片', id: 'PhotoInfo'})
                    }
                    // 备注信息
                    if (carSummaryInfo !== null && carSummaryInfo !== '') {
                        state.ceilingList.push({name: '备注信息', id: 'RemarksInfo'})
                    }
                }
            })
            // tab 切换
            function clickTab(name: string) { // 点击tab切换
                let fileData = ceilingListAll.filter(el => {
                    return el.name === name
                });
                const id: string = fileData[0].id;
                state.needListenScroll = false;
                const sTop = document.documentElement.scrollTop || document.body.scrollTop;
                const eTopEl: any = document.getElementById(id);
                utils.scrollTop(window, sTop, eTopEl.offsetTop - 60, 300);
                setTimeout(() => {
                    state.needListenScroll = true;
                }, 300);
                state.currentName = name
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                openNav()
            }
            // 收起展开选项卡
            function openNav(){
                if(state.isShowTopTab) {
                    state.isShowTopTab = !state.isShowTopTab;
                    document.body.style.overflow = ""
                } else {
                    state.isShowTopTab = !state.isShowTopTab;
                    document.body.style.overflow = "hidden"
                }
            }
            // 滚动事件
            function scrollToTop() {
                if (!state.needListenScroll) return;
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                if (state.reportLevel === 4){
                    // 如果滚动到基本信息的时候  去显示顶部tab
                    if (scrollTop >= 320) {
                        state.isShowTopNav = true;
                    } else {
                        state.isShowTopNav = false;
                    }
                } else {
                    if(state.checkModules.length > 0) {
                        // 如果滚动到基本信息的时候  去显示顶部tab
                        if (scrollTop >= state.offsetTop) {
                            state.isShowTopNav = true;
                        } else {
                            state.isShowTopNav = false;
                        }
                    } else {
                        // 如果滚动到基本信息的时候  去显示顶部tab
                        if (scrollTop >= 680) {
                            state.isShowTopNav = true;
                        } else {
                            state.isShowTopNav = false;
                        }
                    }
                }
                
                state.ceilingList.forEach((item: { id: string; name: string }) => {
                    const getTopEl: any = document.getElementById(item.id);
                    let getTop = getTopEl ? getTopEl.offsetTop : 0;
                    if (scrollTop >= getTop - state.topValue - 60) {
                        state.currentName = item.name;
                    }
                });
            }
            onMounted(() => {
                // 监听dom渲染完成
                nextTick(function(){
                    // 这里BaseInfo是吸顶元素的ID
                    let header: any = document.getElementById("BaseInfo");
                    // 这里要得到top的距离和元素自身的高度
                    state.offsetTop = header.offsetTop;
                    window.addEventListener('scroll', scrollToTop, true);
                });
            })
            onUnmounted(()=> {
                window.removeEventListener('scroll', scrollToTop, false)
            })
            return {
                state,
                openNav,
                clickTab,
                scrollToTop
            }
        },
        methods: {

        }
    })
